import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAddCollectionModalOpen: false,
  urlParams: null,
  model: {},
  changedModel: {},
  supportedFields: [],
  lastVersion: 0,
  usedVersion: 0,
  isUsedVersionUpdatedManually: false,
};

const MappingAliasSlicer = createSlice({
  name: "mappingAlias",
  initialState,
  reducers: {
    setAddCollectionModalState: (state, action) => {
      state.isAddCollectionModalOpen = action.payload;
    },
    setURLParams: (state, action) => {
      state.urlParams = action.payload;
    },
    setModel: (state, action) => {
      state.model = action.payload;
    },
    setChangedModel: (state, action) => {
      state.changedModel = action.payload;
    },
    initialiseVersions: (state, action) => {
      state.lastVersion = action.payload;
      state.usedVersion = action.payload;
    },
    setLastVersion: (state, action) => {
      state.lastVersion = action.payload;
    },
    setUsedVersion: (state, action) => {
      state.usedVersion = action.payload;
      state.isUsedVersionUpdatedManually = true;
    },
    setSupportedFields: (state, action) => {
      state.supportedFields = action.payload;
    },
    addSupportedField: (state, action) => {
      const newSupportedFields = [
        ...state.changedModel?.supportedFields,
        action.payload,
      ];
      state.changedModel = {
        ...state.changedModel,
        supportedFields: newSupportedFields,
      };
      state.supportedFields = newSupportedFields;
    },
    removeSupportedField: (state, action) => {
      const removedField = action.payload;
      const newSupportedFields = state.supportedFields.filter(
        (field) => field != removedField
      );
      state.changedModel = {
        ...state.changedModel,
        supportedFields: newSupportedFields,
      };
      state.supportedFields = newSupportedFields;
    },
    undoAllChanges: (state) => {
      state.changedModel = state.model;
      state.supportedFields = state.model?.supportedFields;
    },
    clearModelInfo: (state) => {
      state.model = {};
      state.changedModel = {};
      state.supportedFields = [];
      state.lastVersion = 0;
      state.usedVersion = 0;
      state.isUsedVersionUpdatedManually = false;
    },
  },
});

export const {
  setAddCollectionModalState,
  setURLParams,
  setModel,
  setChangedModel,
  initialiseVersions,
  setLastVersion,
  setUsedVersion,
  setSupportedFields,
  addSupportedField,
  removeSupportedField,
  undoAllChanges,
  clearModelInfo,
} = MappingAliasSlicer.actions;

export default MappingAliasSlicer.reducer;
